import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { FormSignatureService } from "../../../../Services/FormSignatureService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IFormSignature } from "../../../../Models/Forms/IFormSignature";
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'Signature',
  templateUrl: './Signature.component.html',
  styleUrls: ['./Signature.component.css']
})

export class FormSignatureComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  signatureDB: any = [];
  reportParamArray: IReportParameter[];
  yearAndDayInFuture: Date;
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formSignatureService: FormSignatureService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadFormSignatureDetails();
    //this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let meetingDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.yearAndDayInFuture = new Date(meetingDate.getFullYear() + 1, meetingDate.getMonth(), meetingDate.getDate() + 1);
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock() {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=UnLock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  updateRadioButtonTwoOptions() {
    if (this.signatureDB.discussConcernsYes == true) {
      this.signatureDB.discussConcernsNo = false
    }
    else {
      this.signatureDB.discussConcernsNo = true
    }
  }

  LoadFormSignatureDetails(): void {
    this._formSignatureService.getFormSignature(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormSignature) => {
        this.signatureDB = res;
        this.signatureDB.administratorDate = this.signatureDB.administratorDate == null ? null : new Date(this.signatureDB.administratorDate);
        this.signatureDB.agencyRepDate = this.signatureDB.agencyRepDate == null ? null : new Date(this.signatureDB.agencyRepDate);
        this.signatureDB.districtRepDate = this.signatureDB.districtRepDate == null ? null : new Date(this.signatureDB.districtRepDate);
        this.signatureDB.languageAndSpeechSpecialistDate = this.signatureDB.languageAndSpeechSpecialistDate == null ? null : new Date(this.signatureDB.languageAndSpeechSpecialistDate);
        this.signatureDB.otherDate = this.signatureDB.otherDate == null ? null : new Date(this.signatureDB.otherDate);
        this.signatureDB.parentDate = this.signatureDB.parentDate == null ? null : new Date(this.signatureDB.parentDate);
        this.signatureDB.parentDate1 = this.signatureDB.parentDate1 == null ? null : new Date(this.signatureDB.parentDate1);
        this.signatureDB.parentDate2 = this.signatureDB.parentDate2 == null ? null : new Date(this.signatureDB.parentDate2);
        this.signatureDB.permissionGrantedEffective = this.signatureDB.permissionGrantedEffective == null ? null : new Date(this.signatureDB.permissionGrantedEffective);
        this.signatureDB.pupilDate = this.signatureDB.pupilDate == null ? null : new Date(this.signatureDB.pupilDate);
        this.signatureDB.schoolNurseDate = this.signatureDB.schoolNurseDate == null ? null : new Date(this.signatureDB.schoolNurseDate);
        this.signatureDB.schoolPsychologistDate = this.signatureDB.schoolPsychologistDate == null ? null : new Date(this.signatureDB.schoolPsychologistDate);
        this.signatureDB.specialEdTeacherDate = this.signatureDB.specialEdTeacherDate == null ? null : new Date(this.signatureDB.specialEdTeacherDate);
        this.signatureDB.teacher1Date = this.signatureDB.teacher1Date == null ? null : new Date(this.signatureDB.teacher1Date);
        this.signatureDB.teacher2Date = this.signatureDB.teacher2Date == null ? null : new Date(this.signatureDB.teacher2Date);
      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }


  //Save the Signature
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.updateRadioButtonTwoOptions()

    //update values    
    this._formSignatureService.insertUpdateFormSignature(this.signatureDB)
      .subscribe((res: IFormSignature) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock();
        }
        this.saveClicked = false;
        this.LoadFormSignatureDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock();
    this.LoadFormSignatureDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.signatureDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.signatureDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.signatureDB.iepId.toString() },
      { parameterName: 'ReportPathSpanish', parameterValue: '' },
      { parameterName: 'WaterMarkText', parameterValue: '' },
      { parameterName: 'ShowWaterMark', parameterValue: 'False' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.signatureDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.signatureDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
